import { StudentSyncStatus } from '../../../organization/organization/models/StudentSyncStatus';

export enum Status {
  OVERDUE = 'Overdue',
  UNATTEMPTED = 'Unattempted',
  STARTED = 'Started',
  COMPLETED = 'Completed',
}

export enum LearningPlanStatus {
  SCHEDULED = 'Scheduled',
  ACTIVE = 'Active',
  ARCHIVED = 'Archived',
}

export class CreateLearningPlanInstanceResponseDTO {
  learningPlanInstance: {
    id: string;
  };
}

export class LearningPlanInstanceDTO {
  id: string;
  name: string;
  createdAt: string;
  startAt: string;
  topicArea: TypeTopicArea;
}

export interface TypeTopicArea {
  id: string;
  name: string;
}

export interface TypeTopicAreasResponse {
  topicAreas: TypeTopicArea[];
}

export type TrainingPhaseType = 'Custom' | 'Monthly' | 'Quarterly' | 'Yearly';

export interface TypePhase {
  name: string;
  endsAt?: string;
  courses: string[];
}

export interface TypeLearningPlanInstancePOST {
  learningPlanInstance: {
    name: string;
    topicAreaId: string;
    startDate: string;
    looping: boolean;
    phases: TypePhase[];
    trainingPhaseType: TrainingPhaseType;
  };
}

export class LearningPlanInstancesResponseDTO {
  learningPlanInstances: LearningPlanInstanceDTO[];
}

export class EnrolledStudentDTO {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  syncStatus: StudentSyncStatus;
  phase?: {
    name: string;
    courseInstance: {
      id: string;
      status: Status;
      name?: string;
    };
    startedAt: string;
  };
}
export class LearningPlanInstanceEnrollmentsResponseDTO {
  students: EnrolledStudentDTO[];
}

export class LearningPlanInstanceCourseUserActivitiesResponseDTO {
  students: EnrolledStudentCourseUserActivityDTO[];
}

export class EnrolledStudentCourseUserActivityDTO {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phase?: PhaseCourseUserActivityDTO;
}

export class PhaseCourseUserActivityDTO {
  name: string;
  courseInstance: {
    id: string;
    status: Status;
    timestamp: string;
  };
}

export class Phase {
  id: string;
  name: string;
  endsAt?: string | null;
  nextPhaseId: string | null;
  start: boolean;
  courseInstances: Array<{
    id: string;
    courseId: string;
    name: string;
    numberOfEnrolledStudents: number;
    numberOfCompletedStudents: number;
  }>;
}

export class LearningPlanInstanceDetailDTO extends LearningPlanInstanceDTO {
  numberOfEnrolledStudents: number;
  numberOfEnrolledStudentsLearningPlanStarted: number;
  numberOfCompletedStudents: number;
  phases: Phase[];
  status: LearningPlanStatus;
  canToggleRepetition: boolean;
  periodPickerOptions: PeriodPickerOption[];
  trainingPhaseType: TrainingPhaseType;
}

export class PeriodPickerOption {
  startDate: string;
  endDate: string;
}
export class LearningPlanInstanceDetailResponseDTO {
  learningPlanInstance: LearningPlanInstanceDetailDTO;
}
export class LearningPlanEnrollmentRequestDTO {
  students: Array<{ id: string }>;
}

export class LearningPlanUnenrollmentRequestDTO {
  students: Array<{ id: string }>;
}

export class SendReminderRequestDTO {
  students: Array<{ id: string; courseInstanceId: string }>;
}

export class CourseGalleryItemDTO {
  id: string;
  externalMoodleId: string;
  name: string;
  description: string;
  aboutUrl: string;
}
